import React, { useReducer } from 'react'
import AuctionContext from './auctionContext'
import AuctionReducer from './auctionReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import {
    GET_ALL_AUCTIONS,
    GET_SINGLE_AUCTION,
    GET_AUCTION_PROJECTS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './auctionTypes'

const AuctionState = (props) => {
    const initialState = {
        single_auction: {
            record: {},
        },
        auction_projects: {
            records: [],
        },
        all_auctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(AuctionReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllAuctions = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'lots', formData, '', 'template/auction'),
            ])
            const from = 'Auctions'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_AUCTIONS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const auctionAction = async (formData) => {
        try {
            const from = 'auctionAction'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'auctionAction',
                    formData,
                    '',
                    'template/auction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleAuction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getSingleAuction',
                    formData,
                    '',
                    'template/auction'
                ),
            ])
            const from = 'AuctionManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_AUCTION,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeAuctionStatus = async (formData) => {
        try {
            const from = 'auctionchange'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'changeStatus',
                    formData,
                    '',
                    'template/auction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllAuctProjects = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllProjectsAssociated',
                    formData,
                    '',
                    'template/auction'
                ),
            ])
            const from = 'AuctionManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_AUCTION_PROJECTS,
                    payload: {
                        records: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const assignAuctionLot = async (formData) => {
        try {
            const from = 'auctionLot'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'addtoAuction',
                    formData,
                    '',
                    'template/auction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuctionContext.Provider
            value={{
                all_auctions: state.all_auctions,
                responseStatus: state.responseStatus,
                single_auction: state.single_auction,
                auction_projects: state.auction_projects,
                clearResponse,
                getAllAuctions,
                auctionAction,
                getSingleAuction,
                getAllAuctProjects,
                assignAuctionLot,
                changeAuctionStatus,
            }}
        >
            {props.children}
        </AuctionContext.Provider>
    )
}

export default AuctionState
